import React from "react";
import { motion } from "framer-motion";

const team = [
  { name: "Hana Jeyaraj", initials: "HJ", role: "Founder" },
  { name: "P. Prabakaran", initials: "PP" },
  { name: "Bharath Kumar", initials: "BK" },
  { name: "Dhanabalan", initials: "DB" },
  { name: "John Naveen", initials: "JN" },
  { name: "Manikandan", initials: "MK" },
  { name: "Manoj Kumar", initials: "MJ" },
  { name: "John Britto", initials: "JB" },
];

const Team = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="py-24 lg:py-32 bg-[#f5f5f7] border-t border-[#e5e5e5]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono text-xs text-[#0038FF]">[ 09 ]</span>
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#0038FF]">
                Our Team
              </span>
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              data-testid="team-heading"
              className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl font-black tracking-tighter text-[#0a0a0a] break-words"
            >
              The operators
              <br />
              behind the work.
            </motion.h2>
          </div>
          <p className="text-base text-[#4a4a4a] max-w-md leading-relaxed">
            A tight, senior team — equally at home in code reviews, classrooms
            and kitchens. Names below, real work everywhere our clients run.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#e5e5e5] border border-[#e5e5e5]">
          {team.map((m, idx) => (
            <motion.div
              key={m.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.7,
                delay: idx * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
              data-testid={`team-member-${idx}`}
              className="relative bg-white p-10 lg:p-12 min-h-[260px] flex flex-col justify-between overflow-hidden group hover:bg-[#0a0a0a] transition-colors duration-500"
            >
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -bottom-6 -right-2 font-display text-[10rem] lg:text-[12rem] font-black leading-none tracking-tighter text-[#0a0a0a]/[0.06] group-hover:text-[#0038FF]/30 transition-colors duration-500 select-none"
              >
                {m.initials}
              </span>

              <div className="relative z-10 flex items-center gap-3">
                <span className="font-mono text-xs text-[#0038FF] group-hover:text-[#5b8bff] transition-colors">
                  0{idx + 1}
                </span>
                <span className="block h-px w-8 bg-[#0a0a0a] group-hover:bg-white/40 transition-colors" />
              </div>

              <div className="relative z-10">
                {m.role && (
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] mb-2 inline-block bg-[#0038FF] text-white px-2 py-1 group-hover:bg-white group-hover:text-[#0038FF] transition-colors">
                    {m.role}
                  </div>
                )}
                <div className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-[#0a0a0a] group-hover:text-white transition-colors">
                  {m.name}
                </div>
              </div>
            </motion.div>
          ))}

          {/* Filler card for grid balance */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            data-testid="team-filler"
            className="hidden lg:flex bg-[#0a0a0a] text-white p-10 lg:p-12 min-h-[260px] flex-col justify-between"
          >
            <div className="font-mono text-xs text-[#5b8bff]">[ + ]</div>
            <div>
              <div className="font-display text-2xl lg:text-3xl font-bold tracking-tight">
                And the engineers, designers and operators behind every line of
                code we ship.
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Team;
